import http from 'common-module/src/util/http';

/**
 * 获取配置
 */
export async function getConfigure() {
  const result = await http.post('/jenkins/get-config');
  return { result };
}
/**
 * 注销配置
 */
export async function cancellation() {
  const result = await http.post('/jenkins/disable-config');
  return { result };
}

// Jenkins集成配置是否开启
export async function openJenkins() {
  return http.get('/jenkins/query-enable');
}

// Figma集成是否开启
export async function openFigma() {
  return http.get('/figma/query');
}

/**
 * 获取GitlabCI集成开关状态
 * @param {*} projectId number 项目id
 * @param {*} platform string 平台
 * @returns
 */
export async function checkGitlabCISwitch(platform) {
  return http.get(`/gitlab-task/${platform}/query-enable`, {}, {
    showError: false
  });
}

// 极狐是否开启
export async function openFoxLab(projectId, platform) {
  return http.get(`/gitlab-task/${projectId}/${platform}/query-enable`, {}, {
    showError: false
  });
}

/**
 * 查询GitlabCI和foxLab CI 开启状态
 * @returns
 */
export async function checkCIEnable(platforms) {
  return http.post('/gitlab-task/query-enable-list', { platforms }, {
    showError: false
  });
}


